// extracted by mini-css-extract-plugin
export var logo = "_53-2";
export var logoWrapper = "_53-1";
export var strip = "_53-0";